(function () {
  'use strict';

  angular.module('app').component('providerCreditNotesPage', providerCreditNoteListCtrl());

  function providerCreditNoteListCtrl() {
    return {
      bindings: {},
      controller: ProviderCreditNoteListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/provider-credit-notes/provider-credit-notes-page.component.html',
    };
  }

  ProviderCreditNoteListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'ProviderCreditNoteService',
  ];

  function ProviderCreditNoteListCtrl(
    $location,
    UtilService,
    AbilityService,
    ProviderCreditNoteService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ProviderCreditNoteService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    vm.permissions = {
      canCreate: AbilityService.can('create_providercreditnote_accountadmin'),
    };

    // Methods
    vm.createProviderCreditNote = createProviderCreditNote;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      ProviderCreditNoteService.getProviderCreditNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createProviderCreditNote() {
      $location.path('/provider_credit_notes/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/provider_credit_notes/${item.id}`).search({ mode: mode });
    }
  }
})();
